module.exports = __webpack_public_path__ + "static/media/flights.c7a26ad8.png";